export default __webpack_public_path__ + "static/media/This is Your Community.1b34639a.webp";